"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveUserSetting = exports.SaveUserSetting = exports.SaveUserSettingActionTypes = exports.bulkGetUserSettings = exports.BulkGetUserSettings = exports.BulkGetUserSettingsActionTypes = exports.fetchUserSetting = exports.FetchUserSetting = exports.FetchUserSettingActionTypes = exports.UserSettingsActionTypes = void 0;

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/utils/actions");

var _identity = _interopRequireDefault(require("transmute/identity"));

var UserSettingsActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_USER_SETTING: null,
  BULK_GET_USER_SETTINGS: null,
  SAVE_USER_SETTING: null
}, 'userSettings');
exports.UserSettingsActionTypes = UserSettingsActionTypes;
var FetchUserSettingActionTypes = (0, _actions.createRequestTypes)(UserSettingsActionTypes.FETCH_USER_SETTING);
exports.FetchUserSettingActionTypes = FetchUserSettingActionTypes;
var FetchUserSetting = (0, _actions.createRequestActions)(FetchUserSettingActionTypes, {
  keys: ['namespace', 'key', 'value']
});
exports.FetchUserSetting = FetchUserSetting;
var fetchUserSetting = (0, _fluxActions.createAction)(UserSettingsActionTypes.FETCH_USER_SETTING, (0, _actions.mapPayloadTo)('namespace', 'key', 'value'));
exports.fetchUserSetting = fetchUserSetting;
var BulkGetUserSettingsActionTypes = (0, _actions.createRequestTypes)(UserSettingsActionTypes.BULK_GET_USER_SETTINGS);
exports.BulkGetUserSettingsActionTypes = BulkGetUserSettingsActionTypes;
var BulkGetUserSettings = (0, _actions.createRequestActions)(BulkGetUserSettingsActionTypes);
exports.BulkGetUserSettings = BulkGetUserSettings;
var bulkGetUserSettings = (0, _fluxActions.createAction)(UserSettingsActionTypes.BULK_GET_USER_SETTINGS, _identity.default);
exports.bulkGetUserSettings = bulkGetUserSettings;
var SaveUserSettingActionTypes = (0, _actions.createRequestTypes)(UserSettingsActionTypes.SAVE_USER_SETTING);
exports.SaveUserSettingActionTypes = SaveUserSettingActionTypes;
var SaveUserSetting = (0, _actions.createRequestActions)(SaveUserSettingActionTypes);
exports.SaveUserSetting = SaveUserSetting;
var saveUserSetting = (0, _fluxActions.createAction)(UserSettingsActionTypes.SAVE_USER_SETTING, _identity.default);
exports.saveUserSetting = saveUserSetting;